// Usage: https://www.chartjs.org/
import Chart from "chart.js/auto";

window.Chart = Chart;

